import { render, staticRenderFns } from "./CheckoutCartBox.vue?vue&type=template&id=221c0206&scoped=true"
import script from "./CheckoutCartBox.vue?vue&type=script&lang=js"
export * from "./CheckoutCartBox.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCartBox.vue?vue&type=style&index=0&id=221c0206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c0206",
  null
  
)

export default component.exports